import React from 'react';
import { Search } from 'shared/components';

const ListBlock = (props) => {
	return <Search {...props} />;
};

export default ListBlock;
